export const ratio = (numerator, denominator) => (denominator ? numerator / denominator : null);

/**
 * Compute relative real from theoretical ratio (100% when real but no theoretical).
 * @param {number|null} gapFromTheoretical - The gap between real and theoretical consumption
 * @param {number|null} theoreticalConsumption - The theoretical consumption value
 * @returns {number|null} Percentage (0-100+) or null
 */
export const relativeRealFromTheoreticalRatio = (gapFromTheoretical, theoreticalConsumption) => {
  const backupValue = gapFromTheoretical != null && gapFromTheoretical > 0 ? 100 : null;

  return theoreticalConsumption
    ? ratio(gapFromTheoretical, theoreticalConsumption) * 100
    : backupValue;
};

export const roundWithDecimals = (value, decimals = 2) =>
  Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
